import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=78e94810&scoped=true&"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=78e94810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e94810",
  null
  
)

export default component.exports